/**
 * External Dependencies
 */
import './modules/header';
import './modules/mobileNav';
import './modules/AOS';
import './modules/responsiveVideo';
import './modules/animateTextOnScroll';
import './modules/handleDetails';
import './modules/handleContactForm';
import './modules/categoryDropdown';
import './modules/handlePhoneCTA';
import './modules/glightbox';

import initSliders from './sliders/initSliders';
import handleHomeHero from './modules/handleHomeHero';
window.addEventListener('DOMContentLoaded', () => {
  handleHomeHero();
  initSliders();
});
